// Simple Meta Pixel helper. Falls back to no-op if fbq isn't loaded.
export const trackFbq = (event, params = {}) => {
  if (typeof window === "undefined") return;
  try {
    if (typeof window.fbq === "function") {
      window.fbq("track", event, params);
    }
  } catch (e) {
    // silent
  }
};

export const trackSkoolClick = (source) => {
  trackFbq("Lead", { content_name: `skool-cta-${source}`, content_category: "skool_membership" });
  trackFbq("ViewContent", { content_name: `skool-cta-${source}` });
};

export const trackLeadSubmit = (email) => {
  trackFbq("Lead", { content_name: "guide-5-errores", content_category: "lead_magnet", value: 1, currency: "USD" });
  trackFbq("CompleteRegistration", { content_name: "newsletter", status: "subscribed" });
};
